<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">SEAP vs SICAP</h1>

      <p>
        Începând cu apariția <strong>OUG 34/2006</strong>, în România a fost introdusă platforma <strong>www.e-licitatie.ro</strong>, cunoscută sub numele de <strong>SEAP – Sistemul Electronic de Achiziții Publice</strong>. După o perioadă de adaptare, SEAP a fost considerat stabil și intuitiv de către utilizatori, în special pe browserul <strong>Internet Explorer</strong>.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-laptop-code me-2"></i>Trecerea la SICAP</h5>
      <p>
        În 2016, ca urmare a noii legislații privind achizițiile publice (Legea 98/2016 și legile conexe), a fost lansat în versiune demo noul sistem <strong>SICAP – Sistemul Informatic Colaborativ pentru Achiziții Publice</strong>, adaptat pentru:
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Legea 98/2016 – achiziții publice</li>
        <li><i class="fas fa-check me-2 text-success"></i>Legea 99/2016 – achiziții sectoriale</li>
        <li><i class="fas fa-check me-2 text-success"></i>Legea 100/2016 – concesiuni lucrări/servicii</li>
        <li><i class="fas fa-check me-2 text-success"></i>Legea 101/2016 – căi de atac</li>
      </ul>

      <p>
        SICAP a fost conceput pentru a permite <strong>utilizarea pe dispozitive mobile</strong> și <strong>compatibilitate cu browsere moderne</strong> precum Chrome, eliminând dependența de Internet Explorer.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-history me-2"></i>Perioada de tranziție</h5>
      <p>
        Între mai 2016 și aprilie 2018, <strong>SEAP și SICAP au funcționat în paralel</strong>. Deoarece procedurile active la 02.04.2018 nu au putut fi migrate complet, s-au generat dificultăți și confuzii pentru utilizatori:
      </p>
      <ul>
        <li><i class="fas fa-exclamation-circle me-2 text-warning"></i>Blocaje frecvente în sistem</li>
        <li><i class="fas fa-clock me-2 text-warning"></i>Încetinire a procesului de achiziție directă</li>
        <li><i class="fas fa-sign-out-alt me-2 text-warning"></i>Deconectări aleatorii din platformă</li>
        <li><i class="fas fa-random me-2 text-warning"></i>Splitarea listelor de achiziții directe</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-plus-circle me-2"></i>Îmbunătățiri aduse de SICAP</h5>
      <ul>
        <li><i class="fas fa-bolt me-2 text-primary"></i>Posibilitatea încărcării directe a documentelor din PC</li>
        <li><i class="fas fa-shopping-cart me-2 text-primary"></i>“Coșul de cumpărături” pentru achiziții directe multiple</li>
        <li><i class="fas fa-globe me-2 text-primary"></i>Compatibilitate extinsă cu browsere moderne</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-minus-circle me-2"></i>Limitări actuale</h5>
      <ul>
        <li><i class="fas fa-user-lock me-2 text-danger"></i>Documentele autorităților nu mai pot fi vizualizate fără logare</li>
        <li><i class="fas fa-tachometer-alt me-2 text-danger"></i>Sistemul are performanțe tehnice slabe și instabilitate</li>
        <li><i class="fas fa-shield-alt me-2 text-danger"></i>Posibilă încălcare a <strong>principiului transparenței</strong></li>
      </ul>

      <p class="mt-4">
        În concluzie, SICAP a fost o evoluție necesară din punct de vedere legislativ și tehnic, însă rămân aspecte importante care necesită îmbunătățire.
        Pentru consultanță în utilizarea platformei și gestionarea procedurilor în SICAP:
        <br />
        <strong><i class="fas fa-envelope me-1"></i>contact@consultantaachizitii.ro</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SeapVsSicap'
}
</script>
